import { forwardRef } from "react"
import {
  AppBar,
  Box,
  Dialog,
  DialogContent,
  IconButton,
  Slide,
  Toolbar,
  Typography,
} from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { Close } from "@mui/icons-material"
import { setOpenAllProductsDialog } from "src/features/checkout/checkoutSlice"
import AllProductsInfiniteScroll from "./AllProductsInfiniteScroll"
import AllProductsSearchInput from "./AllProductsSearchInput"

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export default function AllProductsDialog() {
  const dispatch = useDispatch()
  const openAllProductsDialog = useSelector(
    (state) => state.checkout.openAllProductsDialog,
  )
  const onClose = () => dispatch(setOpenAllProductsDialog(false))

  return (
    <Dialog
      fullScreen={true}
      open={openAllProductsDialog}
      onClose={onClose}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ display: { xs: "none", sm: "block" } }}
          >
            All Products
          </Typography>
          <AllProductsSearchInput />
          <Box sx={{ flexGrow: 1 }} />
          <IconButton
            edge="end"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <Close />
          </IconButton>
        </Toolbar>
      </AppBar>

      <DialogContent id="all-products-content" dividers>
        <AllProductsInfiniteScroll />
      </DialogContent>
    </Dialog>
  )
}
